import React, {useContext, useState} from 'react';
import {AppContext} from '../../contexts/AppContext';
import {formatDate, getRoomsFromFilters, getTotalPax} from '../../helpers/base';
import {translate} from '../../helpers/base';
import RoomItem from './RoomItem';

const OccupancyTab = ({onSubmit, onBack, selectedDates}) => {

    const {selectedFilters, setIsBookingBoxOverlayVisible, locale} = useContext(AppContext);

    const defaultRooms = [{adults: 2, children: 0, childAges: []}];
    let initialRooms = getRoomsFromFilters(selectedFilters);
    if(initialRooms.length === 0) {
        initialRooms = defaultRooms;
    }
    const [rooms, setRooms] = useState(initialRooms);

    const checkinDate = selectedDates[0];
    const checkoutDate = selectedDates[1];

    const handleAddRoom = () => {
        setRooms([...rooms, {adults: 2, children: 0, childAges: []}]);
    };

    const handleRemoveRoom = (index) => {
        setRooms(rooms.filter((_, i) => i !== index));
    };

    const handleAdultsChange = (index, delta) => {
        const updatedRooms = [...rooms];
        const newAdults = updatedRooms[index].adults + delta;
        if (newAdults >= 1 && newAdults <= 99) {
            updatedRooms[index].adults = newAdults;
            setRooms(updatedRooms);
        }
    };

    const handleChildrenChange = (index, delta) => {
        const updatedRooms = [...rooms];
        const newChildren = updatedRooms[index].children + delta;
        if (newChildren >= 0 && newChildren <= 99) {
            updatedRooms[index].children = newChildren;

            if (newChildren > updatedRooms[index].childAges.length) {
                updatedRooms[index].childAges.push(0);
            } else {
                updatedRooms[index].childAges.splice(newChildren);
            }

            setRooms(updatedRooms);
        }
    };

    const handleChildAgeChange = (roomIndex, childIndex, age) => {
        const updatedRooms = [...rooms];
        updatedRooms[roomIndex].childAges[childIndex] = age;
        setRooms(updatedRooms);
    };

    const handleReset = () => {
        // setRooms(initialRooms);
        setRooms(defaultRooms);
    };

    const totalPax = getTotalPax(rooms);

    return (
        <div className="content-tab content-tab-persons active">
            <div className="page--overlay--header area--text">
                <span className="lead">{translate('booking-box.rooms.header')}</span>
                <label className="page--overlay--close" onClick={() => setIsBookingBoxOverlayVisible(false)}></label>
            </div>
            <div className="page--overlay--content">
                <div className="booking-box--overlay--rooms">
                    {rooms.map((room, index) => (
                        <RoomItem
                            key={index}
                            room={room}
                            index={index}
                            handleRemoveRoom={handleRemoveRoom}
                            handleAdultsChange={handleAdultsChange}
                            handleChildrenChange={handleChildrenChange}
                            handleChildAgeChange={handleChildAgeChange}
                        />
                    ))}
                </div>
                <div className="text-center">
                    <button className="btn btn-outline btn-sm btn-add" onClick={handleAddRoom}>
                        {translate('booking-box.rooms.addRoom')}
                    </button>
                </div>
            </div>
            <div className="page--overlay--bottom-btns">
                <button
                    type="button"
                    className="btn btn-outline btn-clear clear-room btn-sm"
                    onClick={handleReset}
                    disabled={JSON.stringify(rooms) === JSON.stringify(defaultRooms)}
                >
                    {translate('booking-box.rooms.reset')}
                </button>
                <div>
                    <button
                        type="button"
                        className="booking-box--label btn-switch"
                        onClick={onBack}
                        aria-label="Reisezeitraum & Personen"
                    >
                        <div className="booking-box--label--period">
                            <div className="booking-box--label--date-from">{formatDate(checkinDate, locale)}</div>
                            -
                            <div className="booking-box--label--date-to">{formatDate(checkoutDate, locale)}</div>
                        </div>
                        <div className="booking-box--label--persons">
                            <span>{totalPax}</span> {translate(totalPax === 1 ? 'booking-box.guest' : 'booking-box.guests')}
                        </div>
                        <i className="icon icon--diverses-edit">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 18 18"
                            >
                                <path
                                    stroke="#000"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="1.5"
                                    d="m10.542 4.096 3.362 3.362M3.145 11.493l3.362 3.362m-.336.336 9.75-9.75a.951.951 0 0 0 0-1.345l-2.017-2.017a.951.951 0 0 0-1.345 0l-9.75 9.75L1.8 16.2l4.371-1.009Z"
                                />
                            </svg>
                        </i>
                    </button>
                    <button type="submit" className="btn btn-primary btn-switch btn-sm" onClick={() => onSubmit(rooms)}>
                        {translate('booking-box.rooms.submit')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OccupancyTab;